import {
  VideoSettingsABRValue,
  VideoSettingsAMPValue,
  VideoSettingsAALValue,
  VideoSettingsColorSpaceValue,
} from './videoSettings.enums';
import {VideoSettings} from './videoSettings.types';

export function toLocalVideoSettings(videoSettings: VideoSettings): VideoSettings {
  return {
    ...videoSettings,
    colorSpace: videoSettings.colorSpace || VideoSettingsColorSpaceValue.Empty,
    aal: videoSettings.aal || VideoSettingsAALValue.Empty,
    amp: videoSettings.amp || VideoSettingsAMPValue.Empty,
    abr: videoSettings.abr || VideoSettingsABRValue.Empty,
  };
}

export function toRemoteVideoSettings(
  videoSettings: Partial<VideoSettings>,
): Partial<VideoSettings> {
  return {
    ...videoSettings,
    colorSpace: videoSettings.colorSpace || null,
    aal: videoSettings.aal || null,
    amp: videoSettings.amp || null,
    abr: videoSettings.abr || null,
  };
}
